import { PillarListItemType } from '@data/types';
import React from 'react';

interface Props extends PillarListItemType {}

const PillarListItem: React.FC<Props> = ({ icon, title, text }) => {
  return (
    <li className="w-full md:w-1/3 p-4 md:p-8 text-white">
      <img src={icon} alt="" className="mb-4" />
      <h4 className="text-lg font-lighterNormal leading-snug">{title}</h4>
      <p className="font-normal text-sm mt-4 leading-normal">{text}</p>
    </li>
  );
};

export default PillarListItem;
